<template>
  <v-app class="web">
    <a href="#conteudo" class="skip-link">Pular para o conteúdo</a>

    <app-bar :menu-open="!!drawer" @toggle-menu="drawer = !drawer" />

    <!-- Fora do cabeçalho: o cabeçalho sticky cria um contexto de empilhamento
         que deixaria o menu abaixo do overlay escuro. -->
    <drawer id="menu-mobile" v-model="drawer" :items="items" />

    <view-web id="conteudo" tabindex="-1" />

    <Footer />
  </v-app>
</template>

<script>
import navItems from "@/layouts/web/commons/navItems";

export default {
  name: "Layout",
  components: {
    AppBar: () => import("@/layouts/web/commons/AppBar"),
    Drawer: () => import("@/layouts/web/commons/Drawer"),
    ViewWeb: () => import("@/layouts/web/commons/ViewWeb"),
    Footer: () => import("@/layouts/web/commons/Footer.vue"),
  },
  data: () => ({
    drawer: false,
    items: navItems,
  }),
};
</script>

<style lang="scss">
.web .skip-link {
  position: absolute;
  left: 16px;
  top: -100px;
  z-index: 20;
  padding: 12px 18px;
  background: var(--c-navy);
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  border-radius: var(--radius-sm);

  &:focus {
    top: 16px;
  }
}

.web #conteudo:focus {
  outline: none;
}
</style>
